var _rect, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTotalStaff(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 47,
    height: 47,
    rx: 7.5,
    fill: "#00ACB9",
    fillOpacity: 0.08,
    stroke: "#00ACB9"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2150_8713)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38 17.6092V29.8714C38.0004 31.4962 36.6836 32.8136 35.0588 32.814C35.0584 32.814 35.0581 32.814 35.0578 32.814H12.9422C11.3175 32.8142 10.0002 31.4972 10 29.8725C10 29.8721 10 29.8718 10 29.8715V17.6092C9.99979 15.9844 11.3168 14.6671 12.9416 14.667H12.9423H21.4301V16.2245C21.4298 17.0065 22.0626 17.6413 22.8447 17.6431H25.7396C26.5223 17.6413 27.1563 17.0072 27.1582 16.2245V14.667H35.0579C36.6827 14.6668 37.9999 15.9838 38.0001 17.6086C38 17.6087 38 17.6089 38 17.6092Z",
    fill: "#00ACB9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.782 23.7637C19.6486 23.7635 21.1618 25.2765 21.162 27.143V27.1437V28.1391H14.4023V27.1437C14.4021 25.2771 15.9152 23.7639 17.7817 23.7637H17.782Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.7819 23.7636C19.0076 23.7636 20.0013 22.7737 20.0013 21.5527C20.0013 20.3316 19.0076 19.3418 17.7819 19.3418C16.5561 19.3418 15.5625 20.3316 15.5625 21.5527C15.5625 22.7737 16.5561 23.7636 17.7819 23.7636Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.2651 22.5386H24.8835C24.5563 22.5386 24.291 22.2733 24.291 21.946C24.291 21.6188 24.5563 21.3535 24.8835 21.3535H27.2651C27.5923 21.3535 27.8576 21.6188 27.8576 21.946C27.8575 22.2732 27.5923 22.5386 27.2651 22.5386Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.2786 22.5386H30.196C29.8688 22.5386 29.6035 22.2733 29.6035 21.946C29.6035 21.6188 29.8688 21.3535 30.196 21.3535H34.2786C34.6059 21.3535 34.8711 21.6188 34.8711 21.946C34.8711 22.2732 34.6059 22.5386 34.2786 22.5386Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.2777 24.9136H24.8835C24.5563 24.9136 24.291 24.6483 24.291 24.321C24.291 23.9938 24.5563 23.7285 24.8835 23.7285H34.2777C34.605 23.7285 34.8703 23.9938 34.8703 24.321C34.8703 24.6483 34.605 24.9136 34.2777 24.9136Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.2395 27.2896H24.8835C24.5563 27.2896 24.291 27.0243 24.291 26.697C24.291 26.3698 24.5563 26.1045 24.8835 26.1045H30.2395C30.5668 26.1045 30.832 26.3698 30.832 26.697C30.832 27.0243 30.5667 27.2896 30.2395 27.2896Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.2768 27.2896H33.0613C32.734 27.2896 32.4688 27.0243 32.4688 26.697C32.4688 26.3698 32.734 26.1045 33.0613 26.1045H34.2768C34.604 26.1045 34.8693 26.3698 34.8693 26.697C34.8693 27.0243 34.604 27.2896 34.2768 27.2896Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20.5,
    y: 14.667,
    width: 7,
    height: 3.5,
    fill: "#00ACB9"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2150_8713"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white",
    transform: "translate(10 10)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalStaff);
export default __webpack_public_path__ + "static/media/totalStaff.d5236144c5712967aa56fd7bbf3ebc9b.svg";
export { ForwardRef as ReactComponent };